import { ReactNode } from 'react';
import { Button } from '../button/button';

import './styles.scss';
import { useTypedSelector } from '../../hooks/useTypedSelector';

interface MenuWrapperProps {
  title: string;
  market: string;
  children?: ReactNode;
  submitButtonLabel: string;
  clearButtonLabel?: string;
  isLoading?: boolean;
  withoutCleanAction?: boolean;
  submitAction: () => void;
  clearAction?: () => void;
  isDisabled?: boolean;
}

export const MenuWrapper = ({
  title,
  market,
  children,
  submitButtonLabel,
  clearButtonLabel,
  isLoading = false,
  withoutCleanAction = false,
  submitAction,
  clearAction,
  isDisabled,
}: MenuWrapperProps) => {
  const { displayCharts } = useTypedSelector((state) => state.dashboardState);
  return (
    <div className="menu-wrapper" data-cy={`RealtyOffers-${market}-Container`}>
      <section className="menu-wrapper__title">
        <p>{title}</p>
      </section>
      <section className="menu-wrapper__content">{children}</section>
      {!isLoading && (
        <section className="menu-wrapper__buttons">
          <Button
            cy={`ApplyFilters-${market}`}
            color="primary"
            size="block"
            onClick={submitAction}
            className="btn primary normal block apply-button"
            disabled={
              displayCharts === 'socioeconomicDemographic' || isDisabled
            }
          >
            {submitButtonLabel}
          </Button>
          {!withoutCleanAction && clearButtonLabel && (
            <Button
              cy={`ClearFilters-${market}`}
              variant="outline"
              size="block"
              onClick={clearAction}
              className="btn secondary outline block"
            >
              {clearButtonLabel}
            </Button>
          )}
        </section>
      )}
    </div>
  );
};
